import React, { useEffect, useState } from "react";
import OtpPage from "./sdplotp";
import "../assets/stylesheet/engagement.scss";
import LoginCheck from "../Auth/userAuthentication";
import ForgetPassword from "./sdplforgetPassword";
import OuterLayout from "../shared/sdplouterLayout";
import Button from "react-bootstrap/Button";
import { ShowToastUtil } from "../utilities/showToastUtil";
import ApiRequest from "../services/apiService";
import baseUrl from "../services/baseUrl";
import ScreenLoader from "../components/screenLoader";
import { useNavigate } from "react-router-dom";

const SDPLLoginPage = () => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [company, setCompany] = useState("");
  const [view, setView] = useState("login");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
    setCompany((prev) => ({ ...prev, [company]: value }));
  };

  useEffect(() => {
    localStorage.setItem("loginEmail", credentials.email);
    localStorage.setItem("loginPassKey", credentials.password);
  }, [credentials]);

  const checkIfMoreThanOneHour = (otpDateTime) => {
    const otpDate = new Date(otpDateTime);
    const currentDate = new Date();
    const timeDifference = currentDate - otpDate;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference > 1;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let inputMessage = "";

    if (!credentials.email) {
      inputMessage = "Please enter email";
    } else if (!credentials.password) {
      inputMessage = "Please enter password";
    }

    if (inputMessage) {
      ShowToastUtil(inputMessage, "error");
      return;
    }

    localStorage.setItem("loginEmail", credentials.email);
    localStorage.setItem("loginPassKey", credentials.password);
   // localStorage.setItem("iscompany", credentials.company);

    setLoading(true);
    try {
      let responseData = await handleLogin(credentials, "");
      if (responseData.UserEmail !== null) {
        if (responseData.IsLoggedIn === 1) {
          ShowToastUtil("Concurrent users are terminated.", "warning");
        }
        if (
          responseData.OTPCounter < 5 ||
          checkIfMoreThanOneHour(responseData.OtpDateTime)
        ) {
          localStorage.setItem("userData", JSON.stringify(responseData));
          await handleOTPRequest(credentials);
        } else {
          ShowToastUtil("Too many OTP attempts, try after 1 hour", "warning");
          return;
        }
      } else {
        ShowToastUtil(responseData.ResponseMessage, "error");
      }
    } catch (error) {
      ShowToastUtil("Server not working!", "warning");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (credentials, queryMode) => {
    const email = credentials.email;
    const password = credentials.password;
    let responseData = await LoginCheck(email, password, "login");
    return responseData;
  };
  function encodeBase64(data) {
    if(data){
      return btoa(unescape(encodeURIComponent(data))); 
    }
    else{
      return null;
    }
  }
  const handleOTPRequest = async (credentials) => {
    try {
      const params = new URLSearchParams({
        email: encodeBase64(credentials.email),
        password: encodeBase64(credentials.password),
      });
      const url = `${baseUrl()}/Account/GetOtp?${params.toString()}`;
      const response = await ApiRequest({
        apiLink: url,
        method: "GET",
        getToken: "No",
      });
      if (response) {
        localStorage.setItem("validationKey", response.Data.ValidationKey);
        // navigate('/otp')
        setView("otp");
        ShowToastUtil("OTP has been sent to your registered mobile", "success");
      } else {
        ShowToastUtil("Something went wrong", "error");
      }
    } catch (error) {
      ShowToastUtil("Failed to resend OTP. Please try again.", "error");
    }
  };

  const handleForgetPassword = () => {
    navigate('/sdplforgetPassword');
  };

  const handleBackToLogin = () => {
    setView("login");
  };

  if (loading) {
    return (
      <div className="screenLoader">
        <ScreenLoader />
      </div>
    );
  }

  switch (view) {
    case "otp":
      return (
        <>
          <OtpPage email={credentials.email} password={credentials.password} />
          <button onClick={handleBackToLogin}>Back to Login</button>
        </>
      );
    case "forgetPassword":
      return (
        <>
          <ForgetPassword />
          <button onClick={handleBackToLogin}>Back to Login</button>
        </>
      );
    case "login":
    default:
      return (
        <div className="container-fluid login-wrapper">
          <div className="row align-items-center">
            <OuterLayout />
            <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-4">
              <div className="login-form mt-3 mb-3">
                <div className="form-wrapper">
                  <form onSubmit={handleSubmit}>
                    <h2>Login</h2>
                    <p className="quote">
                      Welcome back! Please login your account to continue...
                    </p>
                    <div className="row">
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="did-floating-label-content">
                          <input
                            className="did-floating-input"
                            type="email"
                            name="email"
                            value={credentials.email}
                            placeholder=""
                            onChange={handleChange}
                            required
                          />
                          <label className="did-floating-label">Email Id</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="did-floating-label-content">
                          <input
                            className="did-floating-input"
                            type="password"
                            name="password"
                            value={credentials.password}
                            placeholder=""
                            onChange={handleChange}
                            required
                          />
                          <label className="did-floating-label">Password</label>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="mb-3 text-center">
                          <Button type="submit" variant="primary">
                            Send OTP
                          </Button>
                        </div>
                      </div>
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 reset-password-link text-end">
                        Forget your Password? Click{" "}
                        <a
                          className="hyperLinkStyling"
                          onClick={handleForgetPassword}
                        >
                          here
                        </a>{" "}
                        to reset.
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
};

export default SDPLLoginPage;
